import * as React from 'react'
import { DropDownList } from '@progress/kendo-react-dropdowns'
export const DropDownTimeZoneCell = (props) => {
    const [localizedData, setLocalizedData] = React.useState(props.timeZoneList)
    
    React.useEffect(() => {
        setLocalizedData(props.timeZoneList)
    }, [props.timeZoneList])

    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value.value,
            })
        }
    }

    const { dataItem } = props
    const field = props.field

    // const dataValue = dataItem[field] === null ? '' : dataItem[field]

    let temp = props.timeZoneValue.find((elem) => Object.keys(elem)[0] === props.dataItem['DES_LOC_PORT'])
    const dataValue =  
        !temp[props.dataItem['DES_LOC_PORT']] ? '' : temp[props.dataItem['DES_LOC_PORT']];

    return (
        localizedData.length && (
            <td>
                {(dataItem.inEdit && (dataItem.TZONE === "" || !dataItem.TZONE)) ? (
                    <DropDownList
                        onChange={handleChange}
                        value={localizedData.find((c) => c.value === dataValue)}
                        data={localizedData}
                        textField="text"
                    />
                ) : (
                    dataValue
                )}
            </td>
        )
    )
}
